import React from "react"
import styled, { css } from "styled-components"
import { Paragraph } from "buoy-core"
import SpecialistResponse from "../../../../interview/components/SpecialistResponse"
import BackButton from "./BackButton"
import CloseIcon from "../../../../common/components/icons/CloseIcon"
import ThankYou from "../../ThankYou"

const PostIntentText = styled(Paragraph).attrs({
  color: "white",
  block: true,
})`
  margin-bottom: 16px;
  ${props =>
    props.disable
      ? css`
          opacity: 0.5;
          cursor: not-allowed;
        `
      : ""};
`

const SpecialistSearch = ({
  showPopUp,
  handleSpecialistSearch,
  submitted,
  specialistSuggestion,
  specialist,
}) => {
  return (
    <React.Fragment>
      <CloseIcon onClick={showPopUp(false)} color="#96cdff" />
      <BackButton onClick={handleSpecialistSearch()} />

      {!submitted && (
        <SpecialistResponse
          placeholder="Search for a specialist"
          item={{ type: "specialistIntentCareOptions" }}
          noSkip
          postIntent
        />
      )}
      {submitted &&
        !specialistSuggestion && (
          <React.Fragment>
            <PostIntentText disable>What type of specialist?</PostIntentText>
            <PostIntentText disable>{specialist}</PostIntentText>
          </React.Fragment>
        )}
      {specialistSuggestion && (
        <PostIntentText>
          Your search for
          <b>{` "${specialistSuggestion}" `}</b>
          did not match our list of specialists. We have noted your entry
        </PostIntentText>
      )}
      {submitted && <ThankYou />}
    </React.Fragment>
  )
}

export default SpecialistSearch



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/SpecialistSearch.js